// 接口地址
let apiBlogEditorUrlMap = new Map();
// apiBlogEditorUrlMap.set('development', '//pj.blog.caixin.com:8999/blog-editor');
apiBlogEditorUrlMap.set('development', '/blog-editor');
apiBlogEditorUrlMap.set('production:tolan', '//blog.caixin.com/blog-editor'); // tolan
apiBlogEditorUrlMap.set('production:topre', '//blogmanage.caixin.com'); // topre
apiBlogEditorUrlMap.set('production', '//blogmanage.caixin.com'); // topub

// 部署路径
let deployUrlMap = new Map();
// deployUrlMap.set('development', '//pj.blog.caixin.com:8999');
deployUrlMap.set('development', '//caixinblog.caixin.com:8999');
deployUrlMap.set('production:tolan', '//blog.caixin.com/cxeditor'); // tolan
deployUrlMap.set('production:topre', '//blogmanage.caixin.com/editblog'); // topre
deployUrlMap.set('production', '//blogmanage.caixin.com/editblog'); // topub

let nodeEnv = process.env.NODE_ENV || 'development';

export let environment = {
  apiBlogEditorUrl: apiBlogEditorUrlMap.get(nodeEnv),
  deployUrl: deployUrlMap.get(nodeEnv),
};
